<template>
  <div class="flex act-container">
    <div>
      <act-preview
        navigationBg="#F72727"
        phoneHeaderFixedColor="#fff"
        :navigationTitle="ruleForm.gameName"
      >
        <div slot="headerSlot">
          <div class="bg"></div>
        </div>
        <div class="slot">
          <div class="header-img-wrapper redeem-upload prev-upload">
            <div class="upload-img" v-if="ruleForm.gameBgp" @click="toggleShow">
              <span class="hmicon icon-shangchuantupian1"></span>
            </div>
            <img class="header-img" :src="ruleForm.gameBgp" alt="" />
            <div
              class="empty"
              style="margin-top:60px; font-size: 12px"
              v-if="!ruleForm.gameBgp"
            >
              还没有主图立即
              <el-button type="primary" size="mini" @click="toggleShow"
                >添加</el-button
              >
            </div>
          </div>
          <div class="preview-goods-list prev-upload">
            <div
              class="upload-img"
              v-if="ruleForm.exclusiveGoodsRuleModels.length"
              @click="addGoods"
            >
              <span
                class="hmicon icon-shangchuantupian1 icon-hao pointer"
              ></span>
            </div>
            <div class="empty" v-if="!ruleForm.exclusiveGoodsRuleModels.length">
              还没有商品立即
              <el-button type="primary" size="mini" @click="addGoods"
                >添加商品</el-button
              >
            </div>
            <template v-if="ruleForm.exclusiveGoodsRuleModels.length">
              <div
                class="goods-item flex"
                v-for="(v, i) in ruleForm.exclusiveGoodsRuleModels"
                :key="i"
              >
                <div class="delete-item" @click="deleteChild(i)">
                  <span class="hmicon  hmicon icon-shanchu1 pointer"></span>
                </div>
                <div class="img-wrapper">
                  <img :src="v.wxshopskupic" alt="" />
                </div>
                <div class="flex-1 flex flex-column flex-between info-wrapper">
                  <div>
                    <div class="goods-name text-overflow-2">
                      {{ v.wxshopSpuName }}
                    </div>
                  </div>
                  <div
                    class="exchange-promition-wrapper"
                    v-if="v.specIdGroupName"
                  >
                    <span class="exchange-promition">
                      {{ v.specIdGroupName }}
                    </span>
                  </div>
                  <div class="flex item-center progress-wrapper">
                    <div
                      class="progress flex flex-between btn light"
                      :style="{
                        background: storeStyle.lightColor
                      }"
                    >
                      <div class="primary btn slide"></div>
                      <div class="progress-info flex flex-between">
                        <span>已抢0</span>
                        <span>0%</span>
                      </div>
                    </div>
                  </div>
                  <div class="flex">
                    <div class="flex-1 flex item-end flex-wrap">
                      <div class="" v-if="v.exclusivePrice">
                        <span :style="{ color: storeStyle.baseColor }">
                          <strong>￥{{ v.exclusivePrice }}</strong>
                        </span>
                      </div>
                      <div v-if="v.wxshopPrice" class="origin-price">
                        ￥{{ v.wxshopPrice }}
                      </div>
                    </div>
                    <div>
                      <div
                        class="btn round"
                        :style="{ background: storeStyle.baseColor }"
                      >
                        去抢购
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </act-preview>
    </div>
    <div class=" add-goods-container">
      <div class="act-step-wrapper">
        <hm-step
          :steps="steps"
          :scroll="true"
          :step="currentStep"
          @scroll="windowScroll"
        ></hm-step>
      </div>
      <div class="act-wrapper">
        <div class="single-active ">
          <el-scrollbar :style="{ height: scrollHeight + 'px' }">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="140px"
            >
              <div id="base">1.基本信息</div>
              <el-form-item label="活动标题" prop="gameName">
                <el-input
                  style="width: 400px"
                  size="small"
                  clearable
                  class="mr10 ipt"
                  v-model.trim="ruleForm.gameName"
                  placeholder="请输入活动标题"
                ></el-input>
              </el-form-item>
              <el-form-item label="活动时间段选择" prop="activityDate">
                <el-date-picker
                  :default-time="['00:00:00', '23:59:59']"
                  v-model="ruleForm.activityDate"
                  :picker-options="pickerOptions0"
                  type="datetimerange"
                  align="right"
                  start-placeholder="活动开始时间"
                  end-placeholder="活动结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  size="small"
                  class="mr10"
                  v-if="!type"
                ></el-date-picker>
                <div v-if="type">
                  开始时间：
                  <el-date-picker
                          :disabled="type === 'details' || (type === 'edit' && updateMode === 'yes')"
                          v-model="ruleForm.activityDate[0]"
                          type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          :default-time="['00:00:00', '23:59:59']"
                          placeholder="开始时间"
                          size="small"
                          class="mr10"
                  >
                  </el-date-picker>
                </div>
                <div v-if="type">
                  结束时间：
                  <el-date-picker
                          size="small"
                          :editable="false"
                          v-model="ruleForm.activityDate[1]"
                          type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          :default-time="'23:59:59'"
                          placeholder="结束时间"
                          :picker-options="pickerOptions"
                  >
                  </el-date-picker>
                </div>
              </el-form-item>
              <el-form-item label="活动分享文案" prop="gameShareContent">
                <el-input
                  :maxlength="30"
                  style="width: 400px"
                  size="small"
                  clearable
                  class="mr10 ipt"
                  v-model.trim="ruleForm.gameShareContent"
                  placeholder="请输入活动分享文案，30字以内"
                ></el-input>
              </el-form-item>
              <el-form-item label="背景音乐链接" prop="gameBgm">
                <el-input
                  style="width: 400px"
                  size="small"
                  clearable
                  class="mr10 ipt"
                  v-model="ruleForm.gameBgm"
                  placeholder="请输入音乐链接/音乐网络地址"
                ></el-input>
              </el-form-item>
              <el-form-item label="主图：" prop="gameBgp">
                <my-upload
                  field="file"
                  @crop-success="cropSuccess"
                  @crop-upload-success="cropUploadSuccess"
                  @crop-upload-fail="cropUploadFail"
                  v-model="show"
                  v-if="show"
                  noCircle
                  noSquare
                  :width="642"
                  :height="308"
                  :headers="{ 'X-Access-Token': $token }"
                  :params="{ fileDir: 'mallDecoration' }"
                  :url="$uploadUrl"
                  img-format="png"
                ></my-upload>
                <div class="flex upload-upload-btn">
                  <div
                    class="btn flex flex-column flex-center open-file"
                    @click="toggleShow"
                    v-if="!ruleForm.gameBgp"
                  >
                    <div class="add-wrapper">
                      <span class="hmicon icon-hao pointer"></span>
                    </div>
                    <span class="gray">上传banner</span>
                  </div>

                  <div
                    v-if="ruleForm.gameBgp"
                    class="mr10 flex item-end priview"
                  >
                    <img class="logo" :src="ruleForm.gameBgp" alt="logo" />
                    <div class="opreat-wrapper flex item-center flex-center">
                      <el-button type="text" @click="toggleShow"
                        >更换</el-button
                      >
                    </div>
                  </div>
                  <div class="form-tip flex flex-column flex-end">
                    图片尺寸建议642x308（最多上传一张）
                  </div>
                </div>
                <!-- <el-button
              type="primary"
              size="small"
              :disabled="type === 'details' || (type === 'edit' && updateMode === 'yes')"
              v-show="!ruleForm.gameBgp"
              @click="toggleShow"
              >上传</el-button
            >
            <span class="form-tip">图片尺寸建议750x360（最多上传一张）</span>
            <div class="priview" v-if="ruleForm.gameBgp">
              <img :src="ruleForm.gameBgp" alt="主图" />
              <div class="opreat-wrapper flex item-center flex-center">
                <el-button
                  type="text"
                  @click="handleRemove"
                  :disabled="type === 'details' || (type === 'edit' && updateMode === 'yes')"
                  >删除</el-button
                >
              </div>
            </div> -->
              </el-form-item>

              <el-form-item label="活动规则说明" prop="gameRuleRemark">
                <hm-rich-editor
                  v-model="ruleForm.gameRuleRemark"
                  :html="ruleForm.gameRuleRemark"
                />
              </el-form-item>
<!--            <el-form-item label="虚拟参与人数" prop="visualJoinNum">-->
<!--            <span>在实际参与人数基础上增加</span-->
<!--            ><el-input-->
<!--              type="number"-->
<!--              maxlength="30"-->
<!--              @mousewheel.prevent.native-->
<!--              style="width: 100px"-->
<!--              size="small"-->
<!--              clearable-->
<!--              class="mr10 ipt"-->
<!--              v-model.trim="ruleForm.visualJoinNum"-->
<!--              placeholder="请输入数字"-->
<!--            ></el-input-->
<!--            >人-->
<!--          </el-form-item>-->
              <div id="gameRule">2.活动规则</div>
              <el-form-item label="规则设置" prop="exclusiveGoodsRuleModels">
                <div
                  class="flex batch flex-between mt10 item-center"
                  v-if="type !== 'details'"
                >
                  <div class="ml10">
                    <el-button size="small" type="text" @click="addGoods"
                      >添加商品</el-button
                    >
                  </div>
                  <div class="flex flex-center">
                    <div @click="outputExcel" class="delete mr20 pointer">
                      <span class="delete-icon hmicon icon-daochu"></span>
                      导出模板
                    </div>
                    <div class="delete mr20 pointer open-file">
                      <span class="delete-icon hmicon icon-daoru"></span>
                      导入
                      <input
                        type="file"
                        @change="importf"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      />
                    </div>
                  </div>
                </div>
                <el-table
                  :data="ruleForm.exclusiveGoodsRuleModels"
                  row-key="wxshopSkuId"
                  border
                  stripe
                  height="500"
                  style="width: 100%"
                >
                  <el-table-column
                    type="index"
                    label="序号"
                    width="50"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="goodsSn"
                    label="商品货号"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="goodsName"
                    label="商品名称"
                    :show-overflow-tooltip="true"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="specIdGroupName"
                    label="规格"
                    :show-overflow-tooltip="true"
                  >
                  </el-table-column>
                  <!-- <el-table-column
              header-align="center"
              align="center"
              prop="stockNum"
              label="库存"
            >
            </el-table-column> -->
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="bargainTotalStockSum"
                    label="活动库存"
                    width="150"
                  >
                    <template slot="header">
                      <el-popover
                        placement="top-start"
                        title="提示"
                        width="200"
                        trigger="hover"
                        content="活动库存为必填"
                      >
                        <div slot="reference">
                          活动库存
                          <span>
                            <i
                              class="el-icon-question"
                              style="fontSize:20px"
                            ></i>
                          </span>
                        </div>
                      </el-popover>
                    </template>
                    <template slot-scope="scope">
                      <el-input
                        :disabled="type === 'details' || (type === 'edit' && updateMode === 'yes' && !scope.row.isNew)"
                        maxlength="30"
                        @mousewheel.prevent.native
                        style="width:100px"
                        v-model.trim="scope.row.bargainTotalStockSum"
                        size="small"
                        @input="
                          filterGt0OrFixed0(
                            'bargainTotalStockSum',
                            scope.$index
                          )
                        "
                        clearable
                        placeholder="活动库存"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                          header-align="center"
                          align="center"
                          prop="goodsName"
                          label="剩余库存"
                  >
                    <template slot-scope="scope">
                      <el-input
                              maxlength="30"
                              ref="surplusStockSum"
                              @mousewheel.prevent.native
                              style="width:100px"
                              v-model.trim="scope.row.surplusStockSum"
                              size="small"
                              @blur="inputYz(scope.row.surplusStockSum)"
                              clearable
                              placeholder="活动库存"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="retailPrice"
                    label="零售价"
                  >
                    <template slot-scope="scope">
                  <el-input
                    clearable
                    style="width:100px"
                    @mousewheel.prevent.native
                    @input="filterGt0OrFixed2('retailPrice', scope.$index)"
                    v-model.trim="scope.row.retailPrice"
                    size="small"
                    placeholder="零售价"
                  ></el-input>
                </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="exclusivePrice"
                    label="专享价"
                  >
                    <template slot-scope="scope">
                      <el-input
                        :disabled="type === 'details' || (type === 'edit' && updateMode === 'yes' && !scope.row.isNew)"
                        clearable
                        style="width:100px"
                        @mousewheel.prevent.native
                        @input="
                          filterGt0OrFixed2('exclusivePrice', scope.$index)
                        "
                        v-model.trim="scope.row.exclusivePrice"
                        size="small"
                        placeholder="专享价"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                      header-align="center"
                      align="center"
                      prop="singleLimit"
                      label="单人限购"
                  >
                    <template slot-scope="scope">
                      <el-input
                          :disabled="type === 'details' || (type === 'edit' && updateMode === 'yes' && !scope.row.isNew)"
                          clearable
                          style="width:100px"
                          @mousewheel.prevent.native
                          @input="
                          filterGt0OrFixed2('singleLimit', scope.$index)
                        "
                          v-model.trim="scope.row.singleLimit"
                          size="small"
                          placeholder="单人限购"
                      ></el-input>
                    </template>
                  </el-table-column>

                  <el-table-column
                    header-align="center"
                    align="center"
                    label="操作"
                    width="200"
                    v-if="type !== 'details'"
                  >
                    <template slot-scope="scope">
                      <div v-if="type !== 'details'">
                        <!-- <el-button
                      size="small"
                      type="text"
                      @click="toFirst(scope.$index)"
                      v-if="scope.$index !== 0"
                      >置顶</el-button
                    >
                    <el-button
                      size="small"
                      type="text"
                      @click="upGo(scope.$index)"
                      v-if="scope.$index !== 0"
                      >上移</el-button
                    >
                    <el-button
                      size="small"
                      type="text"
                      @click="downGo(scope.$index)"
                      v-if="
                        scope.$index !== ruleForm.exclusiveGoodsRuleModels.length - 1 ||
                          scope.$index === 0
                      "
                      >下移</el-button
                    >

                    <el-button
                      size="small"
                      type="text"
                      v-if="
                        scope.$index !== ruleForm.exclusiveGoodsRuleModels.length - 1 ||
                          scope.$index === 0
                      "
                      @click="toBottom(scope.$index)"
                      >置底</el-button
                    > -->
                        <el-button
                          v-if="type !== 'details' && !(type === 'edit' && updateMode === 'yes' && !scope.row.isNew)"
                          size="small"
                          type="text"
                          @click="deleteChild(scope.$index)"
                          >删除</el-button
                        >
                      </div>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column header-align="center" align="center" label="操作">
              <template slot-scope="scope" v-if="type !== 'details'">
                <el-button
                  size="small"
                  type="text"
                  @click="deleteChild(scope.$index)"
                  >删除</el-button
                >
              </template>
            </el-table-column> -->
                </el-table>
              </el-form-item>
              <div id="gameAstrict">
                3.活动限制
              </div>
              <el-form-item label="会员可购买商品的数量" prop="gameBgm">
                <el-input
                    style="width: 200px"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    v-model="ruleForm.buyLimit"
                    placeholder="请输入数量"
                ></el-input>件
              </el-form-item>
              <el-form-item label="活动限制">
                <hm-member-transfer ref="membertransfer"> </hm-member-transfer>
              </el-form-item>
              <el-form-item label="配送方式限制" prop="expressModeGroups">
                <el-checkbox-group v-model="ruleForm.expressModeGroups">
                  <el-checkbox label="shop_extract">门店自提</el-checkbox>
                  <el-checkbox label="express_delivery">快递物流</el-checkbox>
                </el-checkbox-group>
                <div v-if="ruleForm.expressModeGroups.includes('shop_extract')">
                  <shop-picker
                    :available-shops="availableShopList"
                    :selected-shops.sync="selectedShops"
                    :readonly="type === 'details' || (type === 'edit' && updateMode === 'yes')"
                    @change="handleShopPickerChange"
                    style="width: 100%;"
                  />
                </div>
                <div v-if="ruleForm.expressModeGroups.includes('express_delivery')">
                  <el-select
                      size="small"
                      v-model="ruleForm.expressId"
                      filterable
                      class="ml10"
                      clearable
                      placeholder="请选择运费模板"
                  >
                    <el-option
                        :label="v.expressName"
                        :value="v.expressId"
                        v-for="(v, i) in expressList"
                        :key="i"
                    ></el-option>
                  </el-select>
                </div>
              </el-form-item>

            </el-form>
          </el-scrollbar>
          <div class="flex flex-center mt10">
            <el-button
              type="primary"
              size="small"
              @click="submitForm('ruleForm')"
              >发布</el-button
            >
            <el-button size="small" @click="$router.back(-1)">返回</el-button>
          </div>
        </div>
      </div>
    </div>
    <hm-filter-m-s-goods
      type="microShop"
      :visible="dialogVisible"
      :radio="isRadio"
      @saveGoods="saveGoods"
      @setLink="setLink"
      @close="dialogVisible = false"
    ></hm-filter-m-s-goods>
    <el-dialog :visible.sync="errValidGoods" width="30%" title="提示">
      <div>
        <div>
          您有
          <span class="error">{{ errInputResult.length }}</span
          >条数据有误
        </div>
        <el-table :data="errInputResult" border class="small-table">
          <el-table-column
            prop="goodsSn"
            header-align="center"
            align="center"
            label="无效货号"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="specBarcode"
            label="无效条码"
          ></el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import axios from "axios";
import HmStep from "@/components/HmStep";
import myUpload from "vue-image-crop-upload";
import HmRichEditor from "@/components/HmRichEditor";
import XLSX from "xlsx";
import HmFilterMSGoods from "@/components/HmFilterMSGoods";
import HmMemberTransfer from "@/components/HmMemberTransfer";
import Sortable from "sortablejs";
import { arrayUnique2, dataURLtoFile } from "@/utils/utils";
import actPreview from "@/components/actPreview";
import { ShopPicker } from "@/components/shop-picker";
import { mapGetters } from "vuex";
import {getLoginUser} from "@/utils/auth";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {
    HmStep,
    myUpload,
    HmRichEditor,
    HmFilterMSGoods,
    HmMemberTransfer,
    actPreview,
    ShopPicker
  },
  data() {
    const expressModeGroupsStatus = (rule, val, callback) => {
      if (val.findIndex(v => v === "shop_extract") > -1) {
        if (!this.ruleForm.shopIds.length) {
          return callback(new Error("请选择可销售门店"));
        }
      }
      if (val.findIndex(v => v === "express_delivery") > -1) {
        if (!this.ruleForm.expressId) {
          return callback(new Error("请选择运费模板"));
        }
      }

      callback();
    };
    const patterndRuleFunc = (rule, val, callback) => {
      let falg = false;
      this.ruleForm.exclusiveGoodsRuleModels.forEach(v => {
        // if(!v.bargainTotalStockSum|| v.eachPurchaseLimit||v.integralValue){

        // }
        if (
          v.bargainTotalStockSum === "" ||
          v.exclusivePrice === "" ||
          (!v.exclusivePrice && v.exclusivePrice != 0)
        ) {
          falg = true;
        }
        if (falg) {
          return callback(new Error("请输入必填项"));
        }
      });
      callback();
    };
    return {
      storeCode: "",
      expressList: [],
      selectedShops: [],
      pickerOptions: {
        disabledDate(time) {
          let curDate = new Date().getTime();
          // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
          let day = 365 * 24 * 3600 * 1000;
          let dateRegion = curDate + day;
          return (
                  time.getTime() < Date.now() - 8.64e7 || time.getTime() > dateRegion
          );
        }
      },
      saveimg: "",
      // 覆盖的图层信息
      cover_message: [],
      // 历史图层信息
      old_message: [],
      originWidth: null, // 图片原始宽度
      originHeight: null, // 图片原始高度
      zoomWidth: null, // 图片缩放后宽度
      zoomHeight: null, // 图片缩放后高度
      scaleX: 1, // 图片宽度缩放比例（当前实际/原始）
      scaleY: 1, // 图片高度缩放比例（当前实际/原始）
      // 初始canvas
      ctx: null,
      myCanvas: null,
      canvas_operate: null,
      // 截图框
      oRelDiv: null,
      is_canvas: false,
      is_printscreen: false,
      is_canvas_operate: false,
      start_x1: 0,
      start_y1: 0,
      close_x: 0,
      close_y: 0,
      img: null,
      original_img: null,
      screenshot_frame: true,
      fileInput: null,
      rotate_number: 0,
      img_size: 1.0,

      type: this.$route.query.type,
      gameId: this.$route.query.gameId,
      isRadio: false,
      dialogVisible: false,
      errValidGoods: false,
      errInputResult: [],
      pickerOptions0: {
        disabledDate(time) {
          let curDate = new Date().getTime();
          // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
          let day = 365 * 24 * 3600 * 1000;
          let dateRegion = curDate + day;
          return (
            time.getTime() < Date.now() - 8.64e7 || time.getTime() > dateRegion
          );
        }
      },
      ruleForm: {
        activityDate: "",
        gameName: "",
        gameRuleRemark: "",
        gameShareContent: "",
        gameBgm: "",
        buyLimit: "",
        gameBgp:
          "https://imgcdn.hemiao100.com/decoration/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20201020180646.png",
        visualJoinNum: "",
        exclusiveGoodsRuleModels: [],
        expressModeGroups: [],
        shopIds: [],
        expressId: ""
      },
      rules: {
        gameName: [
          {
            required: true,
            message: "请输入活动标题",
            trigger: "blur"
          },
          { min: 2, max: 30, message: "长度在 2 到 30 个字符", trigger: "blur" }
        ],
        activityDate: {
          required: true,
          message: "请输入活动时间",
          trigger: "blur"
        },
        gameShareContent: [
          {
            required: true,
            message: "请输入活动分享文案",
            trigger: "blur"
          }
        ],
        gameBgp: {
          required: true,
          message: "请上传图片",
          trigger: "blur"
        },
        gameRuleRemark: [
          {
            required: true,
            message: "请输入活动规则说明",
            trigger: "blur"
          }
        ],
        visualJoinNum: [
          {
            required: true,
            message: "请输入虚拟参与人数",
            trigger: "blur"
          },
          {
            required: true,
            pattern: /^(0|\+?[1-9][0-9]*)$/,
            message: "请输入正整数",
            trigger: "blur"
          }
        ],
        exclusiveGoodsRuleModels: [
          {
            required: true,
            message: "请设置规则！",
            trigger: "blur"
          },
          {
            required: true,
            validator: patterndRuleFunc,
            trigger: "blur"
          }
        ],
        expressModeGroups: [
          {
            required: true,
            message: "请选择配送方式限制"
          },
          {
            required: true,
            validator: expressModeGroupsStatus
          }
        ]
      },
      show: false,
      scrollHeight: 0,
      currentStep: 1,
      steps: [
        {
          id: "base",
          name: "基本信息"
        },
        {
          id: "gameRule",
          name: "活动规则"
        },
        {
          id: "gameAstrict",
          name: "活动限制"
        }
      ],
      updateMode: ""
    };
  },
  computed: {
    ...mapGetters(["storeStyle", "microShopStoreList", "dkMicroShopStoreList"]),
    availableShopList() {
      if (this.storeCode === '53010017032439' || this.storeCode === '42010216070190') {
        return this.dkMicroShopStoreList || [];
      }
      return this.microShopStoreList || [];
    }
  },
  watch: {
    availableShopList: {
      handler(newList) {
        if (newList && newList.length > 0 && this.ruleForm.shopIds && this.ruleForm.shopIds.length > 0) {
          this.setSelectedShops();
        }
      },
      immediate: true
    }
  },
  created() {
    this.queryExpressList();
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    window.addEventListener("resize", this.handleResize, true);
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;
    console.log("this.storeCode:",this.storeCode);
    if (storeCode === '42010216070190' || storeCode === '53010017032439') {
      this.$store.dispatch("queryDkMicroStoreList");
    } else {
      this.$store.dispatch("queryMicroStoreList");
    }
    this.calcHeight();
    this.rowDrop();
    if (this.type) {
      this.queryDetails();
    }
    this.$store.dispatch("queryStoreStyle");
    // "https://imgcdn.hemiao100.com/ThemePictures/dangren.png"
  },
  destroyed: function() {
    window.removeEventListener("scroll", this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    // 运费模板
    async queryExpressList() {
      const { result } = await this.$store.dispatch("storeExpressConfigList");
      this.expressList = [];
      if (result.defaultTemplate) {
        this.expressList.push(result.defaultTemplate);
      }
      this.expressList.push(...result.templateList);
    },
    handleShopPickerChange(shops) {
      this.ruleForm.shopIds = shops.map(s => s.shopId || s.id);
    },
    setSelectedShops() {
      const shopIds = this.ruleForm.shopIds || [];
      const availableShops = this.availableShopList || [];
      if (shopIds.length === 1 && shopIds[0] === 'all') {
        this.selectedShops = [...availableShops];
      } else if (shopIds.length > 0) {
        this.selectedShops = shopIds.map(shopId => {
          const shop = availableShops.find(s => (s.shopId || s.id) === shopId);
          return shop || { shopId: shopId, shopName: shopId };
        }).filter(s => s);
      } else {
        this.selectedShops = [];
      }
    },
    canvas_submit() {
      let mycanvas = document.getElementById("myCanvas");
      var base64Data = mycanvas.toDataURL("image/jpeg", 1.0);
      this.saveimg = base64Data;
      let file = dataURLtoFile(base64Data);
      var forms = new FormData();
      forms.append("file", file);
      let loading;
      loading = Loading.service({
        lock: true,
        text: "卖力加载中",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0)"
      });
      axios({
        method: "post",
        url: this.$uploadUrl,
        data: forms,
        headers: {
          "Content-Type": "multipart/form-data",
          "X-Access-Token": this.$token
        }
      }).then(res => {
        loading.close();
      });

      this.ctx.save();
    },
    canvas_tiu() {
      this.ctx.restore();
    },
    cropImage(img, cropPosX, cropPosY, width, height, c_or_o) {
      var copy_img = this.ctx.getImageData(cropPosX, cropPosY, width, height);
      var newCanvas = document.createElement("canvas");
      newCanvas.setAttribute("id", "newCanvas");
      newCanvas.width = width * parseInt(this.img_size);
      newCanvas.height = height * parseInt(this.img_size);
      newCanvas.style.border = "1px solid #d3d3d3";
      var newCtx = newCanvas.getContext("2d");
      // clipImgDiv.appendChild(newCanvas);
      newCtx.drawImage(
        this.img,
        cropPosX,
        cropPosY,
        width,
        height,
        0,
        0,
        width * parseInt(this.img_size),
        height * parseInt(this.img_size)
      );
      // 复制并生成 新图层
      if (c_or_o == "copy") {
        var sun_canvas = document.createElement("canvas");
        var sun_ctx = sun_canvas.getContext("2d");
        sun_canvas.id = "suncanvas";
        sun_canvas.width = copy_img.width;
        sun_canvas.height = copy_img.height;
        sun_canvas.style.position = "absolute";
        sun_canvas.style.border = "1px solid";
        sun_ctx.putImageData(copy_img, 0, 0);
        var url = sun_canvas.toDataURL();
        let sonImg = new Image();
        sonImg.style.position = "absolute";
        sonImg.style.top = this.myCanvas.offsetTop + "px";
        sonImg.style.left = this.myCanvas.offsetLeft + "px";
        sonImg.src = url;
        sonImg.alt = "裁剪获得图片...";
        this.myCanvas.parentNode.insertBefore(sonImg, this.myCanvas);
      }
      // 改变原图
      else {
        newCtx.putImageData(copy_img, 0, 0);
        var src = newCanvas.toDataURL("image/png");
        this.ctx.clearRect(0, 0, width, height);
        this.img.src = src;
      }
      // canvas转化为图片
      this.oRelDiv.innerHTML = "";
      this.screenshot_frame = false;
      var cropContainer = document.getElementById("cropContainer");
      var imgDiv = document.getElementById("imgDiv");
      imgDiv.removeChild(cropContainer);
    },
    // 旋转1
    rotate_btn() {
      this.rotate_number += 90;
      var degree = 0;
      degree += parseInt(this.rotate_number);
      degree %= 360;
      this.ctx.save();
      this.ctx.clearRect(0, 0, this.myCanvas.width, this.myCanvas.height);
      this.ctx.translate(this.myCanvas.width / 2, this.myCanvas.height / 2);

      this.ctx.rotate((degree / 180) * Math.PI);
      this.ctx.translate(-this.myCanvas.width / 2, -this.myCanvas.height / 2);

      this.ctx.drawImage(
        this.img,
        this.myCanvas.width / 2 - this.zoomWidth / 2,
        this.myCanvas.height / 2 - this.zoomHeight / 2,
        this.originWidth * this.img_size,
        this.originHeight * this.img_size
      );
      this.ctx.restore();
    },
    // 旋转2
    rotate_btn2() {
      this.rotate_number -= 90;
      var degree = 0;
      degree += parseInt(this.rotate_number);
      degree %= 360;
      this.ctx.save();
      this.ctx.clearRect(0, 0, this.myCanvas.width, this.myCanvas.height);
      this.ctx.translate(this.myCanvas.width / 2, this.myCanvas.height / 2);
      this.ctx.rotate((degree / 180) * Math.PI);
      this.ctx.translate(-this.myCanvas.width / 2, -this.myCanvas.height / 2);
      this.ctx.drawImage(
        this.img,
        this.myCanvas.width / 2 - this.zoomWidth / 2,
        this.myCanvas.height / 2 - this.zoomHeight / 2,
        this.originWidth * this.img_size,
        this.originHeight * this.img_size
      );
      this.ctx.restore();
    },
    async queryDetails() {
      const { result } = await this.$store.dispatch("queryActivitDetail", {
        gameId: this.gameId
      });
      result.expressModeGroups = result.expressModeGroups || [];
      result.shopIds = result.shopIds || [];

      for (let key in this.ruleForm) {
        this.ruleForm[key] = result[key];
      }
      this.ruleForm.activityDate = [result.gameStartTime, result.gameEndTime];
      this.setSelectedShops();
      setTimeout(() => {
        this.$refs.membertransfer.rightData = result.memberThresholdInfoModels;
        this.$refs.membertransfer.rightChecked =
          result.memberThresholdInfoModels;
      }, 100);
      this.updateMode = result.updateMode;
    },

    handleRemove() {
      this.ruleForm.gameBgp = "";
    },
    rowDrop() {
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      const _this = this;
      Sortable.create(tbody, {
        onEnd({ newIndex, oldIndex }) {
          const currRow = _this.ruleForm.exclusiveGoodsRuleModels.splice(
            oldIndex,
            1
          )[0];
          _this.ruleForm.exclusiveGoodsRuleModels.splice(newIndex, 0, currRow);
        }
      });
    },
    // 导出excel
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["商品货号", "商品条码"];
        const filterVal = [];
        const data = this.formatJson(filterVal, []);
        exportJsonToExcel(tHeader, data, "导入模板");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    // 导入excel
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        // const formatResult = [];
        // let isValid = true;
        // let isRequired = true;
        // let goodsSns = [];
        let goodsSnsAndSpecBarcode = [];
        result.forEach(v => {
          // if (v[0]) {
          //   goodsSns.push(v[0]);
          // }
          if (v[0] || v[1]) {
            goodsSnsAndSpecBarcode.push({
              goodsSn: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
              specBarcode: v[1] ? (v[1] + "").replace(/\s*/g, "") : ""
            });
          }
        });

        // goodsSns = unique(goodsSns);
        that.$store
          .dispatch("queryWxshopSkuByGoodsSn", { goodsSnsAndSpecBarcode })
          .then(res => {
            const { code, result } = res;
            if (code === "0") {
              if (result.modelList.length > 0) {
                result.modelList.forEach(v => {
                  v.retailPrice = v.wxshopPrice;
                  v.goodsName = v.wxshopSpuName;
                  v.bargainTotalStockSum = "";
                  v.exclusivePrice = "";
                  v.singleLimit = "";
                });
                that.ruleForm.exclusiveGoodsRuleModels.push(
                  ...result.modelList
                );
                that.ruleForm.exclusiveGoodsRuleModels = arrayUnique2(
                  that.ruleForm.exclusiveGoodsRuleModels,
                  "wxshopSkuId"
                );
                that.$forceUpdate();
                // that.distributionGoodList = [];
                // result.modelList.forEach(v => {
                //   formatResult.forEach(item => {
                //     if (v.goodsSn === item.goodsSn) {
                //       that.distributionGoodList.push(
                //         Object.assign({}, item, v)
                //       );
                //     }
                //   });
                // });
              }
              if (result.errGoodsSnsAndSpecBarcode.length > 0) {
                that.errValidGoods = true;
                that.errInputResult = result.errGoodsSnsAndSpecBarcode;
                // result.errGoodsSnsAndSpecBarcode.forEach(v => {
                //   that.errInputResult.push({ goodsSn: v });
                // });
              }
            }
          });
        // result.forEach(v => {
        //   if (!v[0] || !v[1] || !v[2]) {
        //     isRequired = false;
        //   } else {
        //     if (!that.isString(v[1]) || !that.isString(v[2])) {
        //       isValid = false;
        //       //   that.errValidGoods = true;
        //       //   that.errInputResult.push({
        //       //     name: v[0],
        //       //     mobile: v[1]
        //       //   });
        //     } else {
        //       goodsSns.push(v[0]);
        //       formatResult.push({
        //         goodsSn: v[0] + "",
        //         commissionStartTime: `${v[1]} 00:00:00`,
        //         commissionEndTime: `${v[2]} 23:59:59`,
        //         commissionType:
        //           v[3] === "固定返佣" ? "fixedReturn" : "ratioReturn",
        //         commissionValue: v[4] ? v[4] : "",
        //         agentDiscountValue: v[5] ? v[5] : ""
        //       });
        //     }
        //   }
        // });
        // if (isValid && isRequired) {
        //   let errList = formatResult.filter((item, index, self) => {
        //     for (let i = index + 1; i < self.length; i++) {
        //       if (self[i].goodsSn === item.goodsSn) {
        //         return true;
        //       }
        //     }
        //     return false;
        //   });

        //   if (errList.length > 0) {
        //     that.errValidGoods = true;
        //     that.errInputResult = errList;
        //     that.$message({
        //       message: "导入失败，有重复商品货号！",
        //       type: "warning"
        //     });
        //   } else {
        //     that.$store
        //       .dispatch("queryShareGoodsSn", { goodsSns })
        //       .then(res => {
        //         const { code, result } = res;
        //         if (code === "0") {
        //           if (result.resultList.length > 0) {
        //             that.distributionGoodList = [];
        //             result.resultList.forEach(v => {
        //               formatResult.forEach(item => {
        //                 if (v.goodsSn === item.goodsSn) {
        //                   that.distributionGoodList.push(
        //                     Object.assign({}, item, v)
        //                   );
        //                 }
        //               });
        //             });
        //           }
        //           if (result.errGoodsSns.length > 0) {
        //             that.errValidGoods = true;
        //             that.errInputResult = [];
        //             result.errGoodsSns.forEach(v => {
        //               that.errInputResult.push({ goodsSn: v });
        //             });
        //           }
        //         }
        //       });
        //   }
        // } else {
        //   if (!isRequired) {
        //     that.$message({
        //       message: "导入失败，请导入必填商品信息！",
        //       type: "warning"
        //     });
        //   } else if (!isValid) {
        //     that.$message({
        //       message: "导入失败，日期请使用文本格式导入！",
        //       type: "warning"
        //     });
        //   }
        // }
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    isString(value) {
      return typeof value === "string";
    },
    fixdata(data) {
      // 文件流转BinaryString
      let o = "";
      let l = 0;
      let w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        );
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
    deleteChild(index) {
      this.ruleForm.exclusiveGoodsRuleModels.splice(index, 1);
    },
    setLink() {
      // if (this.currentLinkIndex !== -1) {
      //   this.currentProp[this.currentLinkPropName][
      //     this.currentLinkIndex
      //   ].goodsInfo = row;
      //   this.currentProp[this.currentLinkPropName][
      //     this.currentLinkIndex
      //   ].hrefAddress = `/pages/product/product?wxshopSpuId=${row.wxshopSpuId}`;
      // } else {
      //   this.currentProp.goodsInfo = row;
      //   this.currentProp.hrefAddress = `/pages/product/product?wxshopSpuId=${row.wxshopSpuId}`;
      // }
      this.dialogVisible = false;
      this.isRadio = false;
    },
    addGoods() {
      this.dialogVisible = true;
    },
    saveGoods(data) {
      if (data.length > 0) {
        this.dialogVisible = false;
        // data.forEach(v => {
        //   v.retailPrice = v.wxshopPrice;
        //   v.goodsName = v.wxshopSpuName;
        // });
        // this.ruleForm.exclusiveGoodsRuleModels.push(...data);
        data.map(v => {
          this.ruleForm.exclusiveGoodsRuleModels.push({
            wxshopSkuId: v.wxshopSkuId,
            goodsName: v.wxshopSpuName,
            retailPrice: v.showPrice || v.wxshopPrice,
            goodsSn: v.goodsSn,
            specIdGroupName: v.specIdGroupName,
            isNew: true
          });
        });
        this.ruleForm.exclusiveGoodsRuleModels = arrayUnique2(
          this.ruleForm.exclusiveGoodsRuleModels,
          "wxshopSkuId"
        );
      } else {
        this.$message({
          message: "请选择商品",
          type: "warning"
        });
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.ruleForm));
          params.gameStartTime =
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[0]
              : "";
          params.gameEndTime =
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[1]
              : "";
          params.gameType = "single_single_exclusive";
          params.visualJoinNum = new Number(params.visualJoinNum);

          // params.exclusiveGoodsRuleModels.forEach(v => {
          //   v.goodsName = v.wxshopSpuName;
          // });
          params.memberThresholdInfoModels = this.$refs.membertransfer.rightData;
          let name = (this.type == "details" || this.type == "edit") ? "editActivity" : "addTurntable";
          //if (this.type === "edit") {
            params.gameId = this.gameId;
            params.updateMode = this.updateMode;
            params.isLook = 'yes';
          //}
          this.$store.dispatch(name, params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.$router.back(-1);
            }
          });
        } else {
          return false;
        }
      });
    },
    filterGt0OrFixed2(prop, i) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm.exclusiveGoodsRuleModels[i][
        prop
      ] = this.ruleForm.exclusiveGoodsRuleModels[i][prop].replace(
        /[^\d.]/g,
        ""
      ); //仅保留数字和"."
      this.ruleForm.exclusiveGoodsRuleModels[i][
        prop
      ] = this.ruleForm.exclusiveGoodsRuleModels[i][prop].replace(
        /\.{2,}/g,
        "."
      ); //两个连续的"."仅保留第一个"."
      this.ruleForm.exclusiveGoodsRuleModels[i][
        prop
      ] = this.ruleForm.exclusiveGoodsRuleModels[i][prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm.exclusiveGoodsRuleModels[i][
        prop
      ] = this.ruleForm.exclusiveGoodsRuleModels[i][prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (
        this.ruleForm.exclusiveGoodsRuleModels[i][prop].indexOf(".") < 0 &&
        this.ruleForm.exclusiveGoodsRuleModels[i][prop] != ""
      ) {
        //首位是0的话去掉
        this.ruleForm.exclusiveGoodsRuleModels[i][prop] = parseFloat(
          this.ruleForm.exclusiveGoodsRuleModels[i][prop]
        );
      }
    },
    filterGt0OrFixed0(prop, i) {
      if (prop !== "integralPrice" && prop !== "virtualExchangeNum") {
        this.ruleForm.exclusiveGoodsRuleModels[i][
          prop
        ] = this.ruleForm.exclusiveGoodsRuleModels[i][prop].replace(
          /^(0+)/,
          ""
        ); //过滤0开头
      }

      this.ruleForm.exclusiveGoodsRuleModels[i][
        prop
      ] = this.ruleForm.exclusiveGoodsRuleModels[i][prop].replace(
        /[^\d]+/g,
        ""
      );
      this.ruleForm.exclusiveGoodsRuleModels[i][
        prop
      ] = this.ruleForm.exclusiveGoodsRuleModels[i][prop].replace(
        /\.{2,}/g,
        ""
      ); //两个连续的"."仅保留第一个"."
    },
    handleScroll(e) {
      this.steps.map((v, i) => {
        const ele = document.getElementById(v.id);
        if (ele) {
          const offsetTop = ele.offsetTop;
          if (e.target.scrollTop + 360 > offsetTop) {
            this.currentStep = i + 1;
          } else {
            this.currentStep = i - 1;
          }
        }
      });
    },
    handleResize() {
      this.calcHeight();
    },
    cropSuccess() {},
    cropUploadFail() {},
    cropUploadSuccess(jsonData) {
      if (this.show) {
        this.ruleForm.gameBgp = jsonData.result;
      } else if (this.showDetail) {
        this.uploadedDetailList.push(jsonData.result);
      }
    },
    toggleShow() {
      this.show = !this.show;
    },
    calcHeight() {
      setTimeout(() => {
        const headerHeight = document.querySelector(".navbar")
          ? document.querySelector(".navbar").getBoundingClientRect().y
          : 0;
        const tagHeight = document.querySelector(".tags-view-container")
          ? document
              .querySelector(".tags-view-container")
              .getBoundingClientRect().y
          : 0;
        const stepsHeight = document.querySelector(".step-wrapper")
          ? document.querySelector(".step-wrapper").getBoundingClientRect().y
          : 0;
        const footerHeight = document.querySelector(".el-footer")
          ? document.querySelector(".el-footer").getBoundingClientRect().height
          : 0;
        this.scrollHeight =
          window.innerHeight -
          headerHeight -
          tagHeight -
          stepsHeight -
          footerHeight -
          80;
      }, 0);
    },
    windowScroll(i) {
      this.$nextTick(() => {
        document.getElementById(this.steps[i].id).scrollIntoView();
        this.currentStep = i + 1;
      });
    },
    inputYz(row){
      if(row <= 0 || row == ''){
        this.$message({
          message: "请输入正整数",
          type: "warning"
        });
        this.$refs.surplusStockSum.focus();
      }
    }
  }
};
</script>
<style lang="scss">
.single-active {
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .step-wrapper {
    border-bottom: 1px solid #ddd;
  }
}
</style>
<style lang="scss" scoped>
.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .btn {
    border-radius: 6px;
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    margin-right: 10px;
    width: 80px;
    height: 80px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
      }
    }
  }
}
.priview {
  position: relative;
  width: 300px;
  height: 200px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}

.act-container {
  max-width: 2000px;
  overflow-x: auto;
  .step-wrapper {
    border-bottom: none !important;
    margin-bottom: 0;
  }
  .bg {
    height: 80px;
    background: linear-gradient(to bottom, #f73030, #f6c0c0, #f5f5f5);
    z-index: -1;
  }
  .add-goods-container {
    width: 1128px;
    flex-shrink: 0;
  }
  .slot {
    position: absolute;
    left: 0;
    right: 0;
    top: 70px;
    height: 549px;
    overflow-y: auto;
    .header-img-wrapper {
      box-sizing: border-box;
      padding: 0 15px;
      .header-img {
        width: 100%;
        display: block;
        border-radius: 5px;
      }
    }
    .empty {
      margin-top: 30px;
      text-align: center;
    }

    .preview-goods-list {
      padding: 15px;
      font-size: 12px;
      &:hover {
        .add-goods {
          display: block;
          position: absolute;
          cursor: pointer;
          display: none;
          top: 0;
          left: 0;
          z-index: 9030;
          zoom: 1;
          width: 34px;
          height: 34px;
          font-size: 12px;
          background-color: rgba(0, 0, 0, 0.8);
          border: 1px solid #fff;
          border-radius: 4px;
          text-align: center;
          line-height: 34px;
        }
      }
      .add-goods {
        position: absolute;
        top: 0;
        left: 0;
        display: none;
      }
      .goods-item {
        position: relative;
        background: #fff;
        margin-bottom: 10px;
        padding: 10px;
        border-radius: 5px;
        &:hover {
          .delete-item {
            display: block;
          }
        }
        .img-wrapper {
          width: 110px;
          height: 100px;
          margin-right: 10px;
          img {
            width: 100%;
            border-radius: 4px;
          }
        }

        .goods-name {
          font-size: 14px;
          font-weight: bold;
          margin-bottom: 10px;
        }
        .tag {
          font-size: 12px;
          padding: 0 5px;
          color: #fff;
          border-radius: 30px;
        }

        .origin-price {
          color: #999;
          margin-top: 8px;
          text-decoration: line-through;
        }
      }
    }

    .progress-wrapper {
      margin-bottom: 5px;

      .progress {
        position: relative;
        width: 134px;
        border-radius: 30px;
        overflow: hidden;
        height: 13px;
        line-height: 13px;
        .slide {
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          height: 100%;
          border-radius: 30px;
        }
      }
      .percent {
        font-size: 12px;
        margin-left: 10px;
      }
      .progress-info {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        height: 100%;
        z-index: 1;
        font-size: 10px;
        width: 100%;
        box-sizing: border-box;
        padding: 0 5px;
        color: #fff;
      }
    }
  }
}
</style>
